import moment from 'moment'
import { IAPIWorkingHours, IWorkingHours } from '../interface/IWorkingHours'

export const workingHoursTransformer = (data: IAPIWorkingHours[]): IWorkingHours[] => (
  data.map((workingHour) => ({
    id: workingHour.id,
    type: workingHour.type,
    attributes: {
      id: workingHour.attributes.id,
      userId: workingHour.attributes.user_id,
      startsAt: moment(workingHour.attributes.starts_at, 'HH:mm'),
      duration: workingHour.attributes.duration,
      weekDay: workingHour.attributes.week_day,
      schemaWeek: workingHour.attributes.schema_week,
      isOnlineBookable: workingHour.attributes.is_online_bookable,
    },
  }))
)
